export const Z_INDEXES = {
  ServiceDeskMenu: 2,
  ServiceDeskConversations: 1,
  ServiceDeskConversation: 2,
  ServiceDeskConversationHeader: 4,
  ServiceDeskChatComposer: 4,
  // above the composer: on mobile the details panel is an overlay covering the thread
  ServiceDeskConversationDetails: 5,
  loader: 1000,
  popper: 2000,
} as const;
